// src/ValuedCustomers.jsx
import React, { useState } from "react";
import "./ValuedCustomers.css";

const customers = [
  { name: "Zomato", logo: "/customers/zomato.png" },
  { name: "Jaquar", logo: "/customers/jaquar.svg" },
  { name: "Blinkit", logo: "/customers/blinkit.png" },
  { name: "Uniphos", logo: "/customers/uniphos.png" },
  { name: "Perto", logo: "/customers/perto.png" },
  { name: "Allied Medical", logo: "/customers/allied-medical.png" },
  { name: "Skanray", logo: "/customers/skanray.png" },
  { name: "UltraFast Chargers", logo: "/customers/ultrafast-chargers.png" },
  { name: "IRA", logo: "/customers/ira.png" },
  { name: "Minilec", logo: "/customers/minilec.png" },
];

// Logo image not dropped into public/customers yet (or failed to load) --
// fall back to a clean text wordmark so the strip never shows a broken
// image icon. Swap in the real file at the path above and this stops
// firing automatically.
const CustomerLogo = ({ name, logo }) => {
  const [broken, setBroken] = useState(false);

  return (
    <div className="vc-card">
      {broken ? (
        <span className="vc-wordmark">{name}</span>
      ) : (
        <img
          src={logo}
          alt={name}
          className="vc-logo-img"
          loading="lazy"
          onError={() => setBroken(true)}
        />
      )}
    </div>
  );
};

const ValuedCustomers = () => {
  // Doubled track for a seamless infinite CSS marquee loop.
  const track = [...customers, ...customers];

  return (
    <section className="vc-section">
      <div className="vc-heading-wrap">
        <h2 className="vc-heading">
          Our Valued <span>Customers</span>
        </h2>
        <div className="vc-heading-ornament">
          <div className="vc-orn-line-l" />
          <div className="vc-orn-gem" />
          <div className="vc-orn-line-r" />
        </div>
      </div>

      <div className="vc-marquee">
        <div className="vc-marquee-track">
          {track.map((c, i) => (
            <CustomerLogo key={`${c.name}-${i}`} name={c.name} logo={c.logo} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuedCustomers;
